import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import MizzyDevice from "../MizzyDevice";
import SamplePlayer from "../Voices/SamplePlayer";

var DrumMachine =
/*#__PURE__*/
function (_MizzyDevice) {
  _inherits(DrumMachine, _MizzyDevice);

  function DrumMachine(context, sample_map) {
    var _this;

    _classCallCheck(this, DrumMachine);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DrumMachine).call(this, context));
    _this.map = sample_map;
    return _this;
  }

  _createClass(DrumMachine, [{
    key: "NoteOn",
    value: function NoteOn(MidiEvent) {
      if (this.map.samples[MidiEvent.value] != null) {
        var voice = new SamplePlayer(this.context, this.map.samples[MidiEvent.value].sample.buffer, false, false);
        voice.init();
        this.setVoiceValues();
        voice.connect(this.effectInput);
        voice.on(MidiEvent);
        this.voices[MidiEvent.value] = voice;
      }
    }
  }]);

  return DrumMachine;
}(MizzyDevice);

export { DrumMachine as default };